export default "__VITE_ASSET__Cp9QxVo6__"